/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Profile_Public_EmailInputs */

const cs_settings_profile_public_email = /** @type {(inputs: Settings_Profile_Public_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Veřejný e-mail`)
};

const en_settings_profile_public_email = /** @type {(inputs: Settings_Profile_Public_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Public email`)
};

/**
* | output |
* | --- |
* | "Public email" |
*
* @param {Settings_Profile_Public_EmailInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const settings_profile_public_email = /** @type {((inputs?: Settings_Profile_Public_EmailInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Profile_Public_EmailInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_profile_public_email(inputs)
	return cs_settings_profile_public_email(inputs)
});